module.exports = __webpack_public_path__ + "img/builder-25.72df8a98.webp";